import { ErrorBoundary } from 'components/common/error-boundary';
import { SessionHitsHeaderNew } from 'components/sections/analytics/session-hits/header-new';
import { SessionRecap } from 'components/sections/analytics/session-hits/recap';
import useAnalyticsStore from 'components/sections/analytics/store/use-analytics-store';
import { MachineContext } from 'contexts/machine.context';
import { t } from 'i18next';
import { useContext, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { paths } from 'routes/paths';
import useHittersStore from 'stores/use-hitters-store';

export const AnalyticsSessionHitsNew = () => {
  const navigate = useNavigate();

  const hitters = useHittersStore((s) => s.hitters);

  const { hitterID = '', sessionID = '' } = useParams<{
    hitterID: string;
    sessionID: string;
  }>();

  const { machine } = useContext(MachineContext);

  // we'll need to grab the session info to show in the header
  useEffect(() => {
    if (!machine.machineID) {
      return;
    }

    useAnalyticsStore.getState().fetchSessions({
      machineID: machine.machineID,
      sessionID,
      // we may not have a hitter ID when we're showing anonymous sessions - passing in null will specifically return the no-hitter ID session summary
      hitterID: hitterID || null,
      limit: 1,
    });
  }, [sessionID, hitterID, machine.machineID]);

  const hitter = useMemo(
    () => hitters.find((h) => h._id === hitterID),
    [hitters, hitterID]
  );

  return (
    <ErrorBoundary identifier="AnalyticsSessionHitsNew">
      <SessionRecap
        sessionID={sessionID}
        hitterID={hitterID}
        machineID={machine.machineID}
        header={
          <SessionHitsHeaderNew
            sessionID={sessionID}
            hitterID={hitterID}
            breadcrumbs={[
              {
                label: 'main.hitting-reports',
                onClick: () => navigate(paths.analytics.hittingReports),
              },
              {
                label: hitter?.name ?? t('hitters.anonymous'),
              },
            ]}
            onDeleteSession={() => navigate(paths.analytics.hittingReports)}
          />
        }
      />
    </ErrorBoundary>
  );
};
